var map = {
	"./2018/dust/dust.jpg": 7914,
	"./2018/dust/dust_detail_1.JPG": 4047,
	"./2018/dust/dust_detail_2.JPG": 4864,
	"./2018/dust/dust_open_page_1.JPG": 4416,
	"./2018/dust/dust_open_page_2.JPG": 7167,
	"./2018/dust/dust_open_page_3.JPG": 514,
	"./2018/dust/dust_open_page_4.JPG": 5569,
	"./2018/dust/dust_open_page_5.JPG": 4,
	"./2018/holding_you/holding_you.JPG": 6505,
	"./2018/holding_you/holding_you_detail_1.jpg": 2702,
	"./2018/holding_you/holding_you_detail_2.jpg": 7721,
	"./2018/holding_you/holding_you_detail_3.JPG": 7919,
	"./2018/holding_you_bw/holding_you_bw.JPG": 7373,
	"./2018/holding_you_bw/holding_you_bw_detail_1.JPG": 4009,
	"./2018/holding_you_bw/holding_you_bw_detail_2.JPG": 6014,
	"./2018/holding_you_bw/holding_you_bw_detail_3.jpg": 7764,
	"./2018/holding_you_variations/holding_you_variations.JPG": 4079,
	"./2018/holding_you_variations/holding_you_variations_detail_1.JPG": 4231,
	"./2018/holding_you_variations/holding_you_variations_detail_2.JPG": 5576,
	"./2019/oak/oak.jpg": 9613,
	"./2019/service_on_verstovia/service_on_verstovia.JPG": 6412,
	"./2019/service_on_verstovia/service_on_verstovia_detail_1.JPG": 4890,
	"./2019/service_on_verstovia/service_on_verstovia_detail_2.JPG": 9077,
	"./2019/service_on_verstovia/service_on_verstovia_detail_3.JPG": 7400,
	"./2019/service_on_verstovia_tan/service_on_verstovia_tan.JPG": 1260,
	"./2019/service_on_verstovia_tan/service_on_verstovia_tan_detail_1.JPG": 8842,
	"./2019/service_on_verstovia_tan/service_on_verstovia_tan_detail_2.JPG": 3237,
	"./2020/birch/birch.jpg": 6305,
	"./2020/birch/birch_block.JPG": 9438,
	"./2020/birch/birch_detail.jpg": 8989,
	"./2020/kettle/kettle.jpg": 7713,
	"./2020/kettle/kettle_close.jpg": 76,
	"./2020/sculpting/sculpting.jpg": 5281,
	"./2020/sculpting/sculpting_progress_1.jpg": 6003,
	"./2020/sculpting/sculpting_progress_2.jpg": 9940,
	"./2020/sculpting/sculpting_progress_3.jpg": 4273,
	"./2020/sculpting/sculpting_progress_4.jpg": 6018,
	"./2021/asturian_bridge/asturian_bridge.jpg": 3244,
	"./2021/asturian_bridge/asturian_bridge_detail_1.jpg": 7626,
	"./2021/asturian_bridge/asturian_bridge_detail_2.jpg": 1205,
	"./2021/asturian_bridge/asturian_bridge_detail_3.jpg": 7240,
	"./2021/asturian_bridge/asturian_bridge_full.jpg": 2774,
	"./2021/city_trees/city_trees.JPG": 4957,
	"./2021/city_trees/city_trees_ii.jpg": 2183,
	"./2021/city_trees/city_trees_iii.JPG": 8963,
	"./2021/city_trees/city_trees_iv.JPG": 319,
	"./2021/city_trees/city_trees_v.JPG": 9406,
	"./2021/city_trees/city_trees_vi.JPG": 5721,
	"./2021/city_trees_2/city_trees_2.jpg": 2650,
	"./2021/city_trees_2/city_trees_detail_1.jpg": 4681,
	"./2021/city_trees_2/city_trees_detail_2.jpg": 8542,
	"./2021/city_trees_2/city_trees_detail_3.jpg": 5003,
	"./2021/coats/coats.jpg": 3116,
	"./2021/coats/coats_detail_1.jpg": 8778,
	"./2021/coats/coats_detail_2.jpg": 6005,
	"./2021/coats/coats_detail_3.jpg": 8392,
	"./2021/fabric/fabric.JPG": 9245,
	"./2021/fabric/fabric_layer_1.jpg": 8802,
	"./2021/fabric/fabric_layer_2.JPG": 6672,
	"./2021/fabric/fabric_layer_3.JPG": 1149,
	"./2021/fabric/fabric_layer_4.JPG": 6854,
	"./2021/fabric/fabric_layer_5.JPG": 4867,
	"./2021/journals/first_page.JPG": 7379,
	"./2021/journals/journals.JPG": 4487,
	"./2021/journals/marbled_endpaper_1.JPG": 2420,
	"./2021/journals/marbled_endpaper_10.jpeg": 3386,
	"./2021/journals/marbled_endpaper_11.jpeg": 8657,
	"./2021/journals/marbled_endpaper_12.jpeg": 6240,
	"./2021/journals/marbled_endpaper_13.jpeg": 3943,
	"./2021/journals/marbled_endpaper_14.jpeg": 5838,
	"./2021/journals/marbled_endpaper_15.jpeg": 7221,
	"./2021/journals/marbled_endpaper_16.jpeg": 7364,
	"./2021/journals/marbled_endpaper_17.jpeg": 2571,
	"./2021/journals/marbled_endpaper_18.jpeg": 882,
	"./2021/journals/marbled_endpaper_19.jpeg": 3081,
	"./2021/journals/marbled_endpaper_2.JPG": 4995,
	"./2021/journals/marbled_endpaper_20.jpeg": 3293,
	"./2021/journals/marbled_endpaper_21.jpeg": 4550,
	"./2021/journals/marbled_endpaper_22.jpeg": 2563,
	"./2021/journals/marbled_endpaper_23.jpeg": 1980,
	"./2021/journals/marbled_endpaper_24.jpeg": 3241,
	"./2021/journals/marbled_endpaper_25.JPG": 1370,
	"./2021/journals/marbled_endpaper_26.JPG": 2117,
	"./2021/journals/marbled_endpaper_27.JPG": 9752,
	"./2021/journals/marbled_endpaper_28.JPG": 9699,
	"./2021/journals/marbled_endpaper_29.jpeg": 6161,
	"./2021/journals/marbled_endpaper_3.jpeg": 5748,
	"./2021/journals/marbled_endpaper_3.jpg": 1595,
	"./2021/journals/marbled_endpaper_4.jpeg": 3633,
	"./2021/journals/marbled_endpaper_5.jpeg": 4090,
	"./2021/journals/marbled_endpaper_6.jpeg": 7447,
	"./2021/journals/marbled_endpaper_7.jpeg": 6528,
	"./2021/journals/marbled_endpaper_8.jpeg": 6141,
	"./2021/journals/marbled_endpaper_9.jpeg": 7398,
	"./2021/journals/open_page.JPG": 4441,
	"./2021/landscape/landscape.jpg": 6011,
	"./2021/landscape/landscape_block.JPG": 8743,
	"./2021/landscape/landscape_layer_1.JPG": 3859,
	"./2021/landscape/landscape_layer_2.jpg": 1733,
	"./2021/landscape/landscape_layer_3.JPG": 6929,
	"./2021/landscape/landscape_layer_4.JPG": 8194,
	"./2021/landscape/landscape_layer_5.JPG": 7999,
	"./2021/landscape/landscape_layer_6.JPG": 4624,
	"./2021/landscape/landscape_layer_7.jpg": 5324,
	"./2021/landscape/landscape_layer_8.jpg": 47,
	"./2021/landscape/landscape_layer_9.JPG": 4603,
	"./2021/lighthouse/lighthouse.jpg": 1406,
	"./2021/map_I/map_I.JPG": 9389,
	"./2021/map_I/map_I_close.JPG": 856,
	"./2021/map_I/map_I_detail_1.JPG": 601,
	"./2021/map_I/map_I_detail_2.JPG": 9054,
	"./2021/map_II/map_II.JPG": 8405,
	"./2021/map_II/map_II_detail_1.JPG": 2113,
	"./2021/map_II/map_II_detail_2.JPG": 5830,
	"./2021/map_III/map_III.JPG": 2949,
	"./2021/map_III/map_III_detail_1.JPG": 961,
	"./2021/map_III/map_III_detail_2.JPG": 8070,
	"./2021/map_III/map_III_detail_3.JPG": 4243,
	"./2021/otis/otis.jpg": 2516,
	"./2021/otis/otis_detail.jpg": 4374,
	"./2021/reaching/reaching.jpg": 2376,
	"./2021/sculpture/sculpture.jpg": 1252,
	"./2021/sculpture/sculpture_close.jpg": 4969,
	"./2021/sculpture/sculpture_detail_1.jpg": 3170,
	"./2021/sculpture/sculpture_detail_2.JPG": 678,
	"./2021/sculpture/sculpture_detail_3.JPG": 3203,
	"./2021/sculpture/sculpture_detail_4.JPG": 7616,
	"./2021/sculpture_I/sculpture_I.jpg": 3604,
	"./2021/sculpture_I/sculpture_I_detail_1.jpg": 3746,
	"./2021/sculpture_I/sculpture_I_detail_2.jpg": 3645,
	"./2021/sculpture_I/sculpture_I_layer_1.JPG": 9247,
	"./2021/sculpture_I/sculpture_I_layer_10.JPG": 4335,
	"./2021/sculpture_I/sculpture_I_layer_11.jpg": 313,
	"./2021/sculpture_I/sculpture_I_layer_12.JPG": 9501,
	"./2021/sculpture_I/sculpture_I_layer_2.jpg": 1201,
	"./2021/sculpture_I/sculpture_I_layer_3.jpg": 8871,
	"./2021/sculpture_I/sculpture_I_layer_4.jpg": 3983,
	"./2021/sculpture_I/sculpture_I_layer_5.jpg": 7602,
	"./2021/sculpture_I/sculpture_I_layer_6.jpg": 5405,
	"./2021/sculpture_I/sculpture_I_layer_7.jpg": 3664,
	"./2021/sculpture_I/sculpture_I_layer_8.jpg": 8971,
	"./2021/sculpture_I/sculpture_I_layer_9.jpg": 8814,
	"./2021/self_portrait_with_curtain/self_portrait_with_curtain.JPG": 6727,
	"./2021/self_portrait_with_flowers/self_portrait_with_flowers.JPG": 4975,
	"./2021/the_dance/IMG_3031.JPG": 7147,
	"./2021/the_dance/IMG_3034.JPG": 7098,
	"./2021/the_dance/IMG_3037.JPG": 5269,
	"./2021/the_dance/IMG_3038.JPG": 4838,
	"./2021/the_dance/IMG_3039.JPG": 4323,
	"./2021/the_dance/IMG_3040.JPG": 599,
	"./2021/the_dance/IMG_3041.JPG": 6762,
	"./2021/the_dance/IMG_3042.JPG": 4933,
	"./2021/the_dance/IMG_3044.JPG": 6811,
	"./2021/the_dance/the_dance.JPG": 1661,
	"./2021/the_dance/the_dance_cover.JPG": 193,
	"./2021/the_dance/the_dance_page_1.JPG": 9387,
	"./2022/dieffenbachia/dieffenbachia.jpg": 8263,
	"./2022/dieffenbachia/dieffenbachia_detail_1.jpg": 4223,
	"./2022/dieffenbachia/dieffenbachia_detail_2.jpg": 6848,
	"./2022/grass/grass.jpg": 9303,
	"./2022/grass/grass_layer_1.jpeg": 9178,
	"./2022/grass/grass_layer_10.jpeg": 9806,
	"./2022/grass/grass_layer_11.jpeg": 69,
	"./2022/grass/grass_layer_2.jpeg": 6871,
	"./2022/grass/grass_layer_3.jpeg": 4992,
	"./2022/grass/grass_layer_4.jpeg": 5797,
	"./2022/grass/grass_layer_5.jpeg": 2462,
	"./2022/grass/grass_layer_6.jpeg": 5755,
	"./2022/grass/grass_layer_7.jpeg": 3588,
	"./2022/grass/grass_layer_8.jpeg": 5913,
	"./2022/grass/grass_layer_9.jpeg": 4178,
	"./2022/lily/lily.jpg": 209,
	"./2022/shapes/shapes.JPG": 4716,
	"./2022/vase_with_cloth/vase_with_cloth.jpg": 3863,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix.jpg": 8398,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix_close.jpg": 2867,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix_layer_1.jpg": 8756,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix_layer_2.jpg": 1331,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix_layer_3.jpg": 6566,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix_layer_4.jpg": 2909,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix_layer_5.jpg": 1168,
	"./2023/aguille_du_midi:_chamonix/aguille_du_midi:_chamonix_layer_6.jpg": 1487,
	"./2023/monstera/monstera.jpg": 4066,
	"./2023/ponytail_palm/ponytail_palm.jpg": 2630,
	"./2024/bleeding_heart/bleeding_heart.jpeg": 7370,
	"./2024/bleeding_heart/bleeding_heart_full.jpeg": 1322,
	"./2024/dance/dance.jpeg": 3410,
	"./2024/dance/dance_full.jpeg": 2258,
	"./2024/from_the_dining_room_table/from_the_dining_room_table.jpg": 4061,
	"./2024/from_the_dining_room_table/from_the_dining_room_table_ap.jpg": 2025,
	"./2024/from_the_dining_room_table/from_the_dining_room_table_detail_1.jpg": 9065,
	"./2024/from_the_dining_room_table/from_the_dining_room_table_detail_2.jpg": 3118,
	"./2024/from_the_dining_room_table/from_the_dining_room_table_full.jpeg": 9810,
	"./2024/home_I/home_I.jpeg": 3304,
	"./2024/home_I/home_I_full.jpeg": 923,
	"./2024/home_II/home_II.jpeg": 1570,
	"./2024/home_II/home_II_full.jpeg": 7634,
	"./2024/home_II/home_II_variation.jpeg": 3992,
	"./2024/home_II/home_II_variation_full.jpeg": 9220,
	"./2024/home_III/home_III.jpeg": 4026,
	"./2024/home_III/home_III_full.jpeg": 2682,
	"./2024/painted_lamp/painted_lamp.jpeg": 340,
	"./2024/painted_lamp/painted_lamp_full.jpeg": 8816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4799;